import type { OpportunityDetailDto } from '../dto'
import type { RawValidResponse } from '../../goodstack'

import type { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export const getOpportunityDetails: QueryFn<[string, string], OpportunityDetailDto> = async (
  client,
  [_, opportunityId]
) => {
  const res = await client.get<RawValidResponse<OpportunityDetailDto>>(`v1/opportunities/${opportunityId}/details`, {
    withCredentials: true
  })

  return res.data.data
}

export const getOpportunities: QueryFn<[string, string[]], OpportunityDetailDto[]> = async (
  client,
  [_, opportunityIds]
) => Promise.all(opportunityIds.map(async id => getOpportunityDetails(client, ['getOpportunityDetails', id])))
